export const formatDateTime = (date, convert = false) => {
    if (convert) {
        return date.toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    }
    return new Date(date).toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
}

export const formatDateTimeClean = (date) => {
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

export const formatDateTimeFancy = (date) => {
    const now = new Date();
    const diff = now - date;
    const msPerHour = 3600000;
    const msPerDay = msPerHour * 24;
    const msPerWeek = msPerDay * 7;
    if (diff < msPerHour) {
        return "last hour";
    } else if (diff < msPerDay) {
        const hours = Math.floor(diff / msPerHour);
        return hours + " hours ago";
    } else if (diff < msPerWeek) {
        const days = Math.floor(diff / msPerDay);
        return days + " days ago";
    } else {
        return formatDateTimeClean(date)
    }
}
